<template>
  <div class="bar-chart">
    <div v-if="!sorted.length" class="bar-empty">No data available</div>
    <div v-for="(item, i) in sorted" :key="i" class="bar-row">
      <div class="bar-label">{{ item.label }}</div>
      <div class="bar-track">
        <div class="bar-fill" :style="{ width: barPct(item.value) + '%' }"></div>
      </div>
      <div class="bar-val">{{ item.value.toLocaleString('da-DK') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { required: true, type: Array }
  },
  computed: {
    sorted() {
      return [...this.value]
        .sort((a, b) => b.followers - a.followers)
        .map(s => ({ label: s.country.name, value: s.followers }));
    },
    max() {
      return Math.max(...this.sorted.map(s => s.value), 1);
    }
  },
  methods: {
    barPct(val) {
      return Math.round((val / this.max) * 100);
    }
  }
};
</script>

<style scoped>
.bar-chart { padding: 16px 20px; display: flex; flex-direction: column; gap: 12px; }
.bar-empty { font-size: 13px; color: var(--ink-3); padding: 8px 0; }
.bar-row { display: grid; grid-template-columns: 110px 1fr 56px; align-items: center; gap: 10px; }
.bar-label { font-size: 12px; color: var(--ink-2); text-align: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.bar-track { height: 8px; background: var(--line); border-radius: 99px; overflow: hidden; }
.bar-fill { height: 100%; background: #1e4046; border-radius: 99px; transition: width .4s ease; }
.bar-val { font-size: 12px; color: var(--ink-3); text-align: right; white-space: nowrap; }
</style>